import { render, staticRenderFns } from "./TagMultiselectItem.vue?vue&type=template&id=7ec824df"
import script from "./TagMultiselectItem.vue?vue&type=script&lang=ts"
export * from "./TagMultiselectItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ec824df')) {
      api.createRecord('7ec824df', component.options)
    } else {
      api.reload('7ec824df', component.options)
    }
    module.hot.accept("./TagMultiselectItem.vue?vue&type=template&id=7ec824df", function () {
      api.rerender('7ec824df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/Tags/TagMultiselectItem.vue"
export default component.exports